export default {
  QuickAddText: "Thêm mới (F9)",
  QuickSearchText: "Tìm nhanh (F3)",
  NumberPerPage: "bản ghi trên",
  Page: "trang",
  First: "Đầu",
  Previous: "Trước",
  Of: "của",
  Next: "Sau",
  Latest: "Cuối",
  TotalItem: "Tổng số bản ghi:",
  ValidateFromDate: "Từ ngày phải nhỏ hơn hoặc bằng Đến ngày",
  ValidateToDate: "Đến ngày phải lớn hơn hoặc bằng Từ ngày",
  Paging: {
    Total: "Tổng số bản ghi",
    From: "Từ",
    To: "đến",
    Records: "bản ghi",
  },
  Attachment: {
    Label: "Đính kèm",
    Count: "({0} tệp)",
    Add: "Thêm tệp đính kèm",
    FileNameInvalid: "Tên file không hợp lệ.",
    FileExtensionInvalid: "Định dạng file không hợp lệ.",
    FileLarger5MB: "Kích thước file không được vượt quá 5MB.",
    MaxFile: "Chỉ được phép tải lên tối đa {0} tệp",
    FileMin100KB: "kích thước ảnh tối thiểu là 100kb",
    SpecialFileName: "Tên file upload không được có ký tự đặc biệt",
    MaxFileSize: "Kích thước file không được vượt quá {0}.",
    MaxFileSizeMB: "Kích thước file không được vượt quá {0}MB.",
    UploadFileFailure: "Tải file thất bại",
  },
  i18nHeaderOption: {
    QuickAddText: "Thêm mới (F9)",
    QuickSearchText: "Tìm nhanh (F3)",
    IsBalanceInventory: "Chỉ hiển thị hàng hóa còn tồn",
    MsCombobox_EmptyTextDefault: "Không có dữ liệu hiển thị.",
    MsGrid_NoData: "Không có dữ liệu",
    Filter: {
      Contains: "Chứa",
      Notcontains: "Không chứa",
      StartsWith: "Bắt đầu",
      NotStartsWith: "Không bắt đầu",
      EndsWith: "Kết thúc",
      NotEndsWith: "Không kết thúc",
      Null: "Trống",
      NotNull: "Không trống",
      Equals: "Bằng",
      NotEquals: "Không bằng",
      GreaterThan: "Lớn hơn",
      GreaterThanEquals: "Lớn hơn hoặc bằng",
      LessThan: "Nhỏ hơn",
      LessThanEquals: "Nhỏ hơn hoặc bằng",
    },
    FilterBtn: "Áp dụng",
    ResetBtn: "Bỏ lọc",
    Pin: "Cố định cột này",
    Unpin: "Bỏ cố định cột này",
    ColumnLabel: "Điều kiện lọc",
    InputEmptyText: "Giá trị",
    InputEmptyFrom: "Từ giá trị",
    InputEmptyTo: "Đến",
    Boolean: {
      All: "Tất cả",
      True: "Có",
      False: "Không",
    },
  },
  CustomField: {
    Title: "Thông tin khác",
    Column: {
      Alias: "Tên trường",
      Type: "Kiểu dữ liệu",
    },
    Option: {
      Title: "Thêm giá trị kiểu dữ liệu danh sách",
      Empty: "Nhập mỗi giá trị trên một dòng",
    },
  },
  Combobox: {
    EmptyText: "Nhấn Enter để thêm mới",
  },
};
